import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';
import { GenericSelect } from 'web-ui-components/lib/data/capture';
import FromDate from './FromDate';
import {
  paymentStatusOptions,
  dateIntervalOptions,
} from '../../PaymentHistoryHelper';
import ToDate from './ToDate';
import DateUtils from '../../../../utils/DateUtils';
const minimumMonths = 18;
const filterMinimumDate = moment().subtract(minimumMonths, 'months');

const preppedDateIntervalOptions = dateIntervalOptions.map(
  ({ label, value }) => ({ id: value, labelText: label })
);
const preppedPaymentStatusOptions = paymentStatusOptions.map(
  ({ label, value }) => ({ id: value, labelText: label })
);

class Filter extends Component {
  constructor(props) {
    super(props);
    const { filterCriteria } = this.props;
    this.state = {
      isCustomDateInterval: get(filterCriteria, 'isCustomDateInterval', false),
      selectedDateInterval: get(filterCriteria, 'dateInterval'),
      toDate: get(filterCriteria, 'toDate', moment()),
      fromDate: get(filterCriteria, 'fromDate', moment()),
      selectedStatus: get(filterCriteria, 'status'),
      toMinDate: filterMinimumDate,
      isToDateValid: true,
      isFromDateValid: true,
      fromMaxDate: moment().endOf('day'),
      showFromFormatInValidMessage: false,
      showToFormatInValidMessage: false,
    };
    this.handleDateInterval = this.handleDateInterval.bind(this);
    this.handlePaymentStatus = this.handlePaymentStatus.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
  }

  handleDateInterval(dateInterval) {
    let isCustomDateInterval = false;
    let { toDate, fromDate } = this.state;
    let toMinDate = filterMinimumDate;
    if (dateInterval === 'Custom Date') {
      isCustomDateInterval = true;
      fromDate = moment(toDate).subtract(1, 'month');
      toMinDate = moment(fromDate).endOf('day');
    }
    this.setState(
      {
        selectedDateInterval: dateInterval,
        isCustomDateInterval,
        isFromDateValid: true,
        toMinDate,
        fromMaxDate: moment().endOf('day'),
        fromDate,
      },
      () => {
        if (this.isFilterValid()) {
          this.props.handleDateIntervalChange(dateInterval, fromDate);
        }
      }
    );
  }
  handlePaymentStatus(selectedStatus) {
    this.setState({
      selectedStatus,
    });
    if (this.isFilterValid()) {
      this.props.handlePaymentStatusSelect(selectedStatus);
    }
  }
  handleToDateChange(toDate, dateFormat) {
    if (toDate !== 'Invalid date') {
      const selectedToDate = moment(toDate, dateFormat);
      const isBetweenRange = DateUtils.isBetweenDateRange(
        selectedToDate,
        moment(),
        this.state.fromDate
      );
      if (isBetweenRange) {
        this.setState(
          {
            toDate: selectedToDate,
            fromMaxDate: selectedToDate,
            isToDateValid: true,
          },
          () => {
            if (this.isFilterValid()) {
              this.props.handleToDateChange(selectedToDate.endOf('day'));
            }
          }
        );
      } else {
        this.setState({
          toDate: selectedToDate,
          isToDateValid: false,
          showToFormatInValidMessage: false,
        });
      }
    } else {
      this.setState({
        isToDateValid: false,
        showToFormatInValidMessage: true,
      });
    }
  }
  handleFromDateChange(fromDate, dateFormat) {
    if (fromDate !== 'Invalid date') {
      const selectedFromDate = moment(fromDate, dateFormat);
      const isBetweenRange = DateUtils.isBetweenDateRange(
        selectedFromDate,
        this.state.toDate,
        filterMinimumDate
      );
      if (isBetweenRange) {
        this.setState(
          {
            fromDate: selectedFromDate,
            toMinDate: moment(selectedFromDate).endOf('day'),
            isFromDateValid: true,
          },
          () => {
            if (this.isFilterValid()) {
              this.props.handleFromDateChange(selectedFromDate.endOf('day'));
            }
          }
        );
      } else {
        this.setState({
          fromDate: selectedFromDate,
          isFromDateValid: false,
          showFromFormatInValidMessage: false,
        });
      }
    } else {
      this.setState({
        isFromDateValid: false,
        showFromFormatInValidMessage: true,
      });
    }
  }
  isFilterValid() {
    return this.state.isFromDateValid && this.state.isToDateValid;
  }
  render() {
    const {
      showFromFormatInValidMessage,
      isCustomDateInterval,
      isFromDateValid,
      isToDateValid,
      showToFormatInValidMessage,
    } = this.state;
    const { content } = this.props;
    return (
      <div>
        <div className="filter filter--payment-status-and-history">
          <span id="showingLbl" aria-label="Transactions Showing">
            Showing
          </span>
          <div className="filter__choose-payment-status">
            <GenericSelect
              characterCount={9}
              id="generic-select-payment-status-options"
              items={preppedPaymentStatusOptions}
              onChange={(id) => this.handlePaymentStatus(id)}
              selectedId={this.state.selectedStatus}
            />
          </div>
          <span>transactions for</span>
          <div className="filter__choose-date-interval">
            <GenericSelect
              characterCount={9}
              id="generic-select-date-interval"
              items={preppedDateIntervalOptions}
              onChange={(id) => this.handleDateInterval(id)}
              selectedId={this.state.selectedDateInterval}
            />
          </div>
          {isCustomDateInterval && (
            <FromDate
              handleDateChange={this.handleFromDateChange}
              minDate={filterMinimumDate}
              maxDate={this.state.fromMaxDate}
              date={this.state.fromDate}
              isValid={this.state.isFromDateValid}
            />
          )}
          <span>up to</span>
          <ToDate
            handleDateChange={this.handleToDateChange}
            minDate={this.state.toMinDate}
            maxDate={moment()}
            date={this.state.toDate}
            isValid={this.state.isToDateValid}
          />
        </div>
        {!isFromDateValid && (
          <div className="c-field c-field--error">
            <div className="c-field__controls">
              <div className="c-field__message" role="alert">
                <p>
                  {showFromFormatInValidMessage
                    ? content.chooseDateValidationMsg
                    : content.smePaymentHistoryFilterFromErrorMsg}
                </p>
              </div>
            </div>
          </div>
        )}
        {!isToDateValid && (
          <div className="c-field c-field--error">
            <div className="c-field__controls">
              <div className="c-field__message" role="alert">
                <p>
                  {showToFormatInValidMessage
                    ? content.chooseDateValidationMsg
                    : content.paymentHistoryFilterToFieldErrorMsg}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
Filter.propTypes = {
  content: PropTypes.shape({
    chooseDateValidationMsg: PropTypes.string.isRequired,
    paymentHistoryFilterToFieldErrorMsg: PropTypes.string.isRequired,
    smePaymentHistoryFilterFromErrorMsg: PropTypes.string.isRequired,
  }),
  handlePaymentStatusSelect: PropTypes.func.isRequired,
  handleFromDateChange: PropTypes.func.isRequired,
  handleToDateChange: PropTypes.func.isRequired,
  handleDateIntervalChange: PropTypes.func.isRequired,
  filterCriteria: PropTypes.shape({
    isCustomDateInterval: PropTypes.bool.isRequired,
    dateInterval: PropTypes.string.isRequired,
    toDate: PropTypes.object,
    fromDate: PropTypes.object,
    status: PropTypes.string.isRequired,
  }),
};

Filter.defaultProps = {
  content: {},
};
export default Filter;
